/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ app: NonNullable<unknown> }} Mcp_Connect_Return_LoopbackInputs */

const en_mcp_connect_return_loopback = /** @type {(inputs: Mcp_Connect_Return_LoopbackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`After you choose, you’ll return to ${i?.app} on this computer`)
};

const es_mcp_connect_return_loopback = /** @type {(inputs: Mcp_Connect_Return_LoopbackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Después de elegir, volverás a ${i?.app} en este ordenador`)
};

/**
* | output |
* | --- |
* | "After you choose, you’ll return to {app} on this computer" |
*
* @param {Mcp_Connect_Return_LoopbackInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_connect_return_loopback = /** @type {((inputs: Mcp_Connect_Return_LoopbackInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Connect_Return_LoopbackInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_connect_return_loopback(inputs)
	return en_mcp_connect_return_loopback(inputs)
});